import { render, staticRenderFns } from "./Loginv2Old.vue?vue&type=template&id=ddee3fa6&scoped=true"
import script from "./Loginv2Old.vue?vue&type=script&lang=js"
export * from "./Loginv2Old.vue?vue&type=script&lang=js"
import style0 from "./Loginv2Old.vue?vue&type=style&index=0&id=ddee3fa6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddee3fa6",
  null
  
)

export default component.exports